import { useParams, useNavigate } from "react-router-dom";

import ErrorBoundary from "@/ui/organisms/ErrorBoundary";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

import {
    ViewChartsOfAccountsDetails,
    ViewDatabaseGuard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";

import { routerPaths } from "@/ui/router/routerPaths";
import GridLoader from "@/ui/molecules/GridLoader";

const VIEW_CHART_OF_ACCOUNTS_DETAILS_ACTION_BAR_HEIGHT = 100;

const PageChartsOfAccountsDetails = () => {
    const navigate = useNavigate();

    const { coaId } = useParams<{ coaId: string }>();

    const onClickBackButton = () => {
        navigate(routerPaths.chartsOfAccounts.dashboard("list"));
    };

    const onClickEditMappingsButton = ({ coaId }: { coaId: number }) => {
        navigate(routerPaths.chartsOfAccounts.editMappings(String(coaId)));
    };

    const onClickViewAuditLog = ({ coaId }: { coaId: number }) => {
        navigate(routerPaths.chartsOfAccounts.auditLog(String(coaId)));
    };

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard
                    loader={
                        <GridLoader
                            sx={{
                                paddingTop: `${VIEW_CHART_OF_ACCOUNTS_DETAILS_ACTION_BAR_HEIGHT}px`,
                            }}
                        />
                    }
                >
                    <LayoutFillParentCentered>
                        <ViewChartsOfAccountsDetails
                            coaId={Number(coaId)}
                            onClickBackButton={onClickBackButton}
                            onClickEditMappingsButton={
                                onClickEditMappingsButton
                            }
                            onClickViewAuditLog={onClickViewAuditLog}
                        />
                    </LayoutFillParentCentered>
                </ViewDatabaseGuard>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageChartsOfAccountsDetails;
